<template>
  <div class="report-alaytic-table-container">
    <div v-if="isEmpty" class="empty-state">{{ emptyStateText }}</div>
    <div v-for="item in items" v-else :key="item.id">
      <report-analytic-item
        :id="item._id"
        :title="item.title"
        :model="item.model"
        :filters="getFilters(item)"
        :is-processing="item.processing"
        :is-default="item.default"
        :status="item.status"
        :period="getItemPeriod(item)"
        :type="type"
      />
    </div>
  </div>
</template>

<script>
import ReportAnalyticItem from './ReportAnalyticItem.vue'
export default {
  name: 'ReportAnalyticTable',
  components: { ReportAnalyticItem },
  props: {
    recurrentAnalytics: {
      type: Array,
      default: () => [],
    },
    notRecurrentAnalytics: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'rfv',
      validator: (value) => ['rfv', 'dre'].includes(value),
    },
  },
  computed: {
    items() {
      return this.recurrentAnalytics.concat(this.notRecurrentAnalytics)
    },
    isEmpty() {
      return this.items.length === 0
    },
    emptyStateText() {
      return `Nenhuma análise ${this.type === 'rfv' ? 'da Classificação RFV ' : 'do Faturamento incremental'} a ser exibida `
    },
  },
  methods: {
    getFilters(item) {
      const filters = item.filters
      delete filters.__typename
      return filters
    },
    getItemPeriod(item) {
      return item.model === 'RECURRENT' ? item.recurrent : item.notRecurrent
    },
  },
}
</script>

<style lang="scss" scoped>
.report-alaytic-table-container {
  border-top: 1px solid $cinza-l80;
  .empty-state {
    color: $cinza-0;
    padding: 12px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid $cinza-l80;
  }
}
</style>
